import { Box, Chip, Stack, Typography } from "@mui/material";

import AppChip from "@/common/components/Chip/AppChip";
import AppCounterChip from "@/common/components/Chip/AppCounterChip";
import AppIconChip from "@/common/components/Chip/AppIconChip";
import InlineCode from "@/common/components/Code/InlineCode";
import AppIcon from "@/common/components/Icons/AppIcon";
import AppTooltip from "@/common/components/Tooltip/AppTooltip";

export function DevChips() {
  return (
    <Box sx={{ py: 1, px: 2, backgroundColor: (th) => th.palette.background.paper }}>
      <Typography component='div' variant='h4' sx={{ my: 2 }}>
        Chips
      </Typography>

      <Typography component='div' variant='h5' sx={{ my: 2 }}>
        <InlineCode>MUI Chips</InlineCode>
      </Typography>
      <Stack direction='column' spacing={2}>
        <Stack direction='row' spacing={1}>
          <Chip
            variant='filled'
            label={
              <>
                filled <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='outlined'
            label={
              <>
                outlined <AppIcon of='accessory' />
              </>
            }
          />
        </Stack>

        <Stack direction='row' spacing={1}>
          <Chip
            size='extraSmall'
            label={
              <>
                extraSmall <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            size='small'
            label={
              <>
                small <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            size='medium'
            label={
              <>
                medium <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            size='large'
            label={
              <>
                large <AppIcon of='accessory' />
              </>
            }
          />
        </Stack>

        <Stack direction='row' spacing={1}>
          <Chip
            size='extraSmall'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            size='small'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            size='medium'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            size='large'
            label={
              <>
                <AppIcon of='accessory' fontSize='medium' inText />
              </>
            }
          />
        </Stack>

        <Stack direction='row' spacing={1}>
          <Chip
            variant='filled'
            color='default'
            label={
              <>
                filled default <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='filled'
            color='primary'
            label={
              <>
                filled primary <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='filled'
            color='secondary'
            label={
              <>
                filled secondary <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='filled'
            color='info'
            label={
              <>
                filled info <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='filled'
            color='error'
            label={
              <>
                filled error <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='filled'
            color='warning'
            label={
              <>
                filled warning <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='filled'
            color='success'
            label={
              <>
                filled success <AppIcon of='accessory' />
              </>
            }
          />
        </Stack>

        <Stack direction='row' spacing={1}>
          <Chip
            variant='outlined'
            color='default'
            label={
              <>
                outlined default <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='outlined'
            color='primary'
            label={
              <>
                outlined primary <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='outlined'
            color='secondary'
            label={
              <>
                outlined secondary <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='outlined'
            color='info'
            label={
              <>
                outlined info <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='outlined'
            color='error'
            label={
              <>
                outlined error <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='outlined'
            color='warning'
            label={
              <>
                outlined warning <AppIcon of='accessory' />
              </>
            }
          />
          <Chip
            variant='outlined'
            color='success'
            label={
              <>
                outlined success <AppIcon of='accessory' />
              </>
            }
          />
        </Stack>
      </Stack>

      <Typography component='div' variant='h5' sx={{ my: 2 }}>
        <InlineCode>AppChip</InlineCode>
      </Typography>
      <Stack direction='column' spacing={2}>
        <Stack direction='row' spacing={1}>
          <AppChip
            size='extraSmall'
            shape='square'
            label={
              <>
                extraSmall square <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='small'
            shape='square'
            label={
              <>
                small square <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='medium'
            shape='square'
            label={
              <>
                medium square <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='large'
            shape='square'
            label={
              <>
                large square <AppIcon of='accessory' />
              </>
            }
          />
        </Stack>

        <Stack direction='row' spacing={1}>
          <AppChip
            size='extraSmall'
            shape='round'
            label={
              <>
                extraSmall round <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='small'
            shape='round'
            label={
              <>
                small round <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='medium'
            shape='round'
            label={
              <>
                medium round <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='large'
            shape='round'
            label={
              <>
                large round <AppIcon of='accessory' />
              </>
            }
          />
        </Stack>

        <Stack direction='row' spacing={1}>
          <AppChip
            size='extraSmall'
            shape='square'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='small'
            shape='square'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='medium'
            shape='square'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='large'
            shape='square'
            label={
              <>
                <AppIcon of='accessory' fontSize='medium' inText />
              </>
            }
          />
        </Stack>

        <Stack direction='row' spacing={1}>
          <AppChip
            size='extraSmall'
            shape='round'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='small'
            shape='round'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='medium'
            shape='round'
            label={
              <>
                <AppIcon of='accessory' />
              </>
            }
          />
          <AppChip
            size='large'
            shape='round'
            label={
              <>
                <AppIcon of='accessory' fontSize='medium' inText />
              </>
            }
          />
        </Stack>
      </Stack>

      <Typography component='div' variant='h5' sx={{ my: 2 }}>
        <InlineCode>AppIconChip</InlineCode>
      </Typography>
      <Stack direction='column' spacing={2}>
        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='filled' isDefaultEnterDelays>
            <AppIconChip variant='filled' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
          <AppTooltip title='outlined' isDefaultEnterDelays>
            <AppIconChip variant='outlined' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='extraSmall' isDefaultEnterDelays>
            <AppIconChip size='extraSmall' shape='square' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
          <AppTooltip title='small' isDefaultEnterDelays>
            <AppIconChip size='small' shape='square' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
          <AppTooltip title='medium' isDefaultEnterDelays>
            <AppIconChip size='medium' shape='square' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
          <AppTooltip title='large' isDefaultEnterDelays>
            <AppIconChip size='large' shape='square' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='extraSmall' isDefaultEnterDelays>
            <AppIconChip size='extraSmall' shape='round' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
          <AppTooltip title='small' isDefaultEnterDelays>
            <AppIconChip size='small' shape='round' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
          <AppTooltip title='medium' isDefaultEnterDelays>
            <AppIconChip size='medium' shape='round' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
          <AppTooltip title='large' isDefaultEnterDelays>
            <AppIconChip size='large' shape='round' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='outlined default' isDefaultEnterDelays>
            <AppIconChip variant='outlined' color='default' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='outlined primary' isDefaultEnterDelays>
            <AppIconChip variant='outlined' color='primary' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='outlined secondary' isDefaultEnterDelays>
            <AppIconChip variant='outlined' color='secondary' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='outlined info' isDefaultEnterDelays>
            <AppIconChip variant='outlined' color='info' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='outlined error' isDefaultEnterDelays>
            <AppIconChip variant='outlined' color='error' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='outlined warning' isDefaultEnterDelays>
            <AppIconChip variant='outlined' color='warning' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='outlined success' isDefaultEnterDelays>
            <AppIconChip variant='outlined' color='success' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='filled default' isDefaultEnterDelays>
            <AppIconChip variant='filled' color='default' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='filled primary' isDefaultEnterDelays>
            <AppIconChip variant='filled' color='primary' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='filled secondary' isDefaultEnterDelays>
            <AppIconChip variant='filled' color='secondary' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='filled info' isDefaultEnterDelays>
            <AppIconChip variant='filled' color='info' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='filled error' isDefaultEnterDelays>
            <AppIconChip variant='filled' color='error' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='filled warning' isDefaultEnterDelays>
            <AppIconChip variant='filled' color='warning' icon={<AppIcon of='accessory' />} />
          </AppTooltip>

          <AppTooltip title='filled success' isDefaultEnterDelays>
            <AppIconChip variant='filled' color='success' icon={<AppIcon of='accessory' />} />
          </AppTooltip>
        </Stack>
      </Stack>

      <Typography component='div' variant='h5' sx={{ my: 2 }}>
        <InlineCode>AppCounterChip</InlineCode>
      </Typography>
      <Stack direction='column' spacing={2}>
        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='filled' isDefaultEnterDelays>
            <AppCounterChip variant='filled' count={9} />
          </AppTooltip>

          <AppTooltip title='outlined' isDefaultEnterDelays>
            <AppCounterChip variant='outlined' count={9} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='extraSmall' isDefaultEnterDelays>
            <AppCounterChip size='extraSmall' security='square' count={9} />
          </AppTooltip>
          <AppTooltip title='small' isDefaultEnterDelays>
            <AppCounterChip size='small' security='square' count={9} />
          </AppTooltip>

          <AppTooltip title='medium' isDefaultEnterDelays>
            <AppCounterChip size='medium' security='square' count={9} />
          </AppTooltip>

          <AppTooltip title='large' isDefaultEnterDelays>
            <AppCounterChip size='large' security='square' count={9} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='extraSmall' isDefaultEnterDelays>
            <AppCounterChip size='extraSmall' security='round' count={9} />
          </AppTooltip>
          <AppTooltip title='small' isDefaultEnterDelays>
            <AppCounterChip size='small' security='round' count={9} />
          </AppTooltip>

          <AppTooltip title='medium' isDefaultEnterDelays>
            <AppCounterChip size='medium' security='round' count={9} />
          </AppTooltip>

          <AppTooltip title='large' isDefaultEnterDelays>
            <AppCounterChip size='large' security='round' count={9} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='extraSmall' isDefaultEnterDelays>
            <AppCounterChip size='extraSmall' count={99} />
          </AppTooltip>
          <AppTooltip title='small' isDefaultEnterDelays>
            <AppCounterChip size='small' count={99} />
          </AppTooltip>
          <AppTooltip title='medium' isDefaultEnterDelays>
            <AppCounterChip size='medium' count={99} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='extraSmall' isDefaultEnterDelays>
            <AppCounterChip size='extraSmall' count={999} />
          </AppTooltip>
          <AppTooltip title='small' isDefaultEnterDelays>
            <AppCounterChip size='small' count={999} />
          </AppTooltip>
          <AppTooltip title='medium' isDefaultEnterDelays>
            <AppCounterChip size='medium' count={999} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='outlined default' isDefaultEnterDelays>
            <AppCounterChip variant='outlined' color='default' count={9} />
          </AppTooltip>

          <AppTooltip title='outlined primary' isDefaultEnterDelays>
            <AppCounterChip variant='outlined' color='primary' count={9} />
          </AppTooltip>

          <AppTooltip title='outlined secondary' isDefaultEnterDelays>
            <AppCounterChip variant='outlined' color='secondary' count={9} />
          </AppTooltip>

          <AppTooltip title='outlined info' isDefaultEnterDelays>
            <AppCounterChip variant='outlined' color='info' count={9} />
          </AppTooltip>

          <AppTooltip title='outlined error' isDefaultEnterDelays>
            <AppCounterChip variant='outlined' color='error' count={9} />
          </AppTooltip>

          <AppTooltip title='outlined warning' isDefaultEnterDelays>
            <AppCounterChip variant='outlined' color='warning' count={9} />
          </AppTooltip>

          <AppTooltip title='outlined success' isDefaultEnterDelays>
            <AppCounterChip variant='outlined' color='success' count={9} />
          </AppTooltip>
        </Stack>

        <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
          <AppTooltip title='filled default' isDefaultEnterDelays>
            <AppCounterChip variant='filled' color='default' count={9} />
          </AppTooltip>

          <AppTooltip title='filled primary' isDefaultEnterDelays>
            <AppCounterChip variant='filled' color='primary' count={9} />
          </AppTooltip>

          <AppTooltip title='filled secondary' isDefaultEnterDelays>
            <AppCounterChip variant='filled' color='secondary' count={9} />
          </AppTooltip>

          <AppTooltip title='filled info' isDefaultEnterDelays>
            <AppCounterChip variant='filled' color='info' count={9} />
          </AppTooltip>

          <AppTooltip title='filled error' isDefaultEnterDelays>
            <AppCounterChip variant='filled' color='error' count={9} />
          </AppTooltip>

          <AppTooltip title='filled warning' isDefaultEnterDelays>
            <AppCounterChip variant='filled' color='warning' count={9} />
          </AppTooltip>

          <AppTooltip title='filled success' isDefaultEnterDelays>
            <AppCounterChip variant='filled' color='success' count={9} />
          </AppTooltip>
        </Stack>
      </Stack>
    </Box>
  );
}
